import React, { useState } from 'react';
import { HashRouter as Router, Routes, Route, Link } from 'react-router-dom';
import telecom from './assets/telecom.jpg';
import projectMgmt from './assets/project-management.jpg';
import stakeholder from './assets/stakeholder-coordination.jpg';
import rightOfWay from './assets/right-of-way.jpg';
import trees from './assets/trees.jpg';
// import mark from './assets/mark.jpg';
// import melva from './assets/melva.jpg';
// import angel from './assets/angel.jpg';
// import manoj from './assets/manoj.jpg';
// import sajin from './assets/sajin.jpg';
import cables from './assets/cables.jpg';
import meeting from './assets/meeting.jpg';
import houses from './assets/houses.jpg';
import teamwork from './assets/teamwork.jpg';
import { ReactComponent as LogoTxt } from './assets/logos/logo-txt.svg';

// const team = [
//     {
//         name: 'Mark Danskin',
//         title: 'IT Specialist',
//         photo: mark,
//         bio: 'Mark brings a strong background in computer science and DevOps, with a focus on automation, systems integration, and secure digital infrastructure. As the team’s IT lead, he supports platform scalability, technical toolchains, and cloud-based solutions that power design operations.',
//     },
//     {
//         name: 'Melva Joseph',
//         title: 'Project Manager',
//         photo: melva,
//         bio: 'Melva is a trained architect and applied planner with experience coordinating telecom infrastructure design across complex urban and residential projects. Her multidisciplinary background enables her to manage permit workflows, ensure regulatory alignment, and oversee design quality throughout a project’s lifecycle.',
//     },
//     {
//         name: 'Angel Mary Joseph',
//         title: 'Accounting Specialist',
//         photo: angel,
//         bio: 'Angel is a finance professional with a background in global banking and business administration, bringing precision and oversight to budgeting, reporting, and financial planning. As the teams accountant, she ensures fiscal responsibility, cost tracking, and operational efficiency.',
//     },
//     {
//         name: 'Manoj Sixtus',
//         title: 'Telecommunications Designer',
//         photo: manoj,
//         bio: 'Manoj specializes in telecommunications design and project strategy, combining hands-on design experience with a strong foundation in business management. With direct experience in FTTH (Fibre to the Home) builds, he focuses on design optimization and operational workflows to support scalable, high-performance infrastructure solutions.',
//     },
//     {
//         name: 'Sajin Nochur Guruvayurappan',
//         title: 'Electrical Engineer',
//         photo: sajin,
//         bio: 'Sajin is an electrical engineer with deep expertise in OSP/FTTx telecom design, project scheduling, and construction coordination. His comprehensive skill set spans utility design, safety compliance, and resource management, making him a cornerstone for technical delivery and project execution.',
//     },
// ];

const servicesData = [
    {
        id: 'network-planning',
        title: 'Network Planning & Design',
        points: [
            'End-to-End Network Design (From source to building demarcation)',
            'Underground & Aerial Design',
            'Submarine Cable and River Crossing Design',
            'Fibre, Copper, and Coaxial Network Design',
            'Brownfield and Relocation Planning',
            'Route Optimization and Capacity Planning',
            'Standards Compliance & Design Quality Assurance',
        ],
    },
    {
        id: 'ftth-premises',
        title: 'FTTx & Premises Infrastructure',
        points: [
            'FTTx Planning and Design',
            'MDU (Multi-Dwelling Unit) & SFU (Single Family Unit) Design',
            'Fibre Distribution Hub (FDH) Design & Placement Strategy',
            'Commercial and Institutional Premises Design',
            'Pre-servicing for New Developments',
            'Retrofit Design for Existing Structures',
            'Smart Building Integration Readiness (IoT, access control, etc.)',
        ],
    },
    {
        id: 'project-execution',
        title: 'Project Execution & Construction Management',
        points: [],
        subsections: [
            {
                subtitle: 'Construction & Project Management',
                points: [
                    'Design-Build Coordination and Phasing Support',
                    'Risk Management',
                    'Timeline and Budget Tracking',
                    'Subcontractor Coordination',
                    'As-Built Verification and Sign-off Support',
                    'Progress Reporting and Client Communication',
                ],
            },
            {
                subtitle: 'Material Coordination',
                points: [
                    'Material Planning and Forecasting',
                    'Bill of Materials (BOM) Preparation',
                    'Material Ordering and Vendor Coordination',
                    'Delivery Tracking and On-Time Logistics',
                    'Inventory Management',
                    'Procurement Support for Specialized Equipment',
                ],
            },
        ],
    },
    {
        id: 'permitting',
        title: 'Permitting & Regulatory Coordination',
        points: [
            'Permit Application Management & Tracking',
            'Municipal Consent & Local Authority Liaison',
            'Utility Line Assignment and Excavation Permits',
            '3rd Party Pole Attachment & Detailed Pole Load Analysis',
            'Environmental, Conservation & Waterway Approvals',
            'Highway, Bridge & Rail Crossing Permits',
            'First Nations Consultation Coordination (where applicable)',
        ],
    },
    {
        id: 'right-of-way',
        title: 'Right-of-Way & Easement Management',
        points: [
            'ROW Design and Drawing Packages',
            'Cross-jurisdictional Utility ROW Coordination',
            'Landowner Liaison and Agreement Support',
            'Title Review for Easement Conflicts',
        ],
    },
    {
        id: 'gis-documentation',
        title: 'GIS & Documentation Services',
        points: [],
        subsections: [
            {
                subtitle: 'Geographic Information Systems (GIS)',
                points: [
                    'GIS as a Service (GISaaS) for Telecom & Utilities',
                    'As-Built and Network Update Integration',
                    'Custom Landbase Creation and Hosting',
                    'Spatial Analysis and Route Planning Support',
                    'Data Migration from CAD to GIS',
                ],
            },
            {
                subtitle: 'Work Documentation',
                points: [
                    'Detailed Work Plans and Construction Packages',
                    'Post-Construction As-Built Records',
                    'Redline Review and Digital Markup Integration',
                    'Project Closeout Packages',
                ],
            },
        ],
    },
];

const Navbar = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <nav className="bg-white shadow-md font-bold tracking-wider font-sans z-50 fixed w-full top-0 left-0">
            <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
                <LogoTxt className="h-12" aria-label="Anterro" />
                {/* Burger icon for mobile */}
                <button className="lg:hidden flex flex-col justify-center items-center w-8 h-8" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
                    <span className={`block h-1 w-6 bg-gray-800 mb-1 rounded transition-all ${menuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                    <span className={`block h-1 w-6 bg-gray-800 mb-1 rounded transition-all ${menuOpen ? 'opacity-0' : ''}`}></span>
                    <span className={`block h-1 w-6 bg-gray-800 rounded transition-all ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                </button>
                {/* Menu links */}
                <div
                    className={`flex-col lg:flex-row lg:flex space-y-4 lg:space-y-0 lg:space-x-8 absolute lg:static top-16 left-0 w-full lg:w-auto bg-white lg:bg-transparent shadow-lg lg:shadow-none z-50 transition-all duration-200 ${
                        menuOpen ? 'flex' : 'hidden'
                    }`}
                >
                    <Link to="/" className="hover:text-sky-700 transition-colors px-6 py-2 block" onClick={() => setMenuOpen(false)}>
                        Home
                    </Link>
                    <Link to="/about" className="hover:text-sky-700 transition-colors px-6 py-2 block" onClick={() => setMenuOpen(false)}>
                        About
                    </Link>
                    {/* <Link to="/portfolio" className="hover:text-sky-700 transition-colors px-6 py-2 block" onClick={() => setMenuOpen(false)}>
                        Portfolio
                    </Link> */}
                    <Link to="/services" className="hover:text-sky-700 transition-colors px-6 py-2 block" onClick={() => setMenuOpen(false)}>
                        Services
                    </Link>
                    <Link to="/contact" className="hover:text-sky-700 transition-colors px-6 py-2 block" onClick={() => setMenuOpen(false)}>
                        Contact
                    </Link>
                </div>
            </div>
        </nav>
    );
};

const Footer = () => (
    <footer className="bg-gray-900 text-white mt-12 p-12 text-center text-sm !my-0">
        <div className="flex justify-center space-x-6 mb-4">
            {/* <a href="#" className="hover:underline">
                Placeholder 1
            </a>
            <a href="#" className="hover:underline">
                Placeholder 2
            </a>
            <a href="#" className="hover:underline">
                Placeholder 3
            </a> */}
        </div>
        <div>© {new Date().getFullYear()} Anterro. All rights reserved.</div>
    </footer>
);

const Section = ({ imageLeft, color, title, text, image, serviceId }) => (
    <div className={`flex flex-col lg:flex-row ${imageLeft ? 'lg:flex-row-reverse' : ''} items-center my-20 gap-8 px-6`}>
        <div className={`w-full lg:w-1/2 aspect-video rounded-3xl shadow-md ${color} flex items-center justify-center`}>
            {image ? <img src={image} alt={title} className="object-cover w-full h-full rounded-3xl" /> : <span className="text-white text-xl font-bold">Image Placeholder</span>}
        </div>
        <div className="w-full lg:w-1/2 text-center px-10 flex flex-col items-center">
            <h2 className="text-2xl font-semibold mb-2 text-center text-sky-800">{title}</h2>
            <p className="text-base text-gray-700 mb-4">{text}</p>
            {serviceId && (
                <Link
                    to={`/services#${serviceId}`}
                    className="mt-2 px-6 py-2 bg-sky-700/80 text-white rounded-lg border-2 border-transparent hover:border-gray-800 transition-colors text-base font-semibold"
                >
                    Learn More
                </Link>
            )}
        </div>
    </div>
);

const Home = () => (
    <div className="p-6 !p-0">
        <div className="w-full h-96 flex items-center justify-center bg-center bg-cover relative" style={{ backgroundImage: `url(${trees})` }}>
            <div className="text-center my-20 text-white px-6">
                <h1 className="text-6xl font-semibold mb-4">Welcome to Anterro</h1>
                <p className="text-2xl">Your partner in telecom infrastructure design and planning</p>
                <button className="mt-6 px-8 py-3 bg-sky-700 text-white font-semibold rounded-lg border-2 border-transparent hover:border-white transition-colors">
                    <Link to="/contact">Get in Touch</Link>
                </button>
            </div>
        </div>
        <div className="max-w-6xl mx-auto w-full py-12 px-6 text-center">
            <div className="flex items-center justify-center relative my-16">
                <div className="text-center px-6">
                    <h1 className="text-4xl font-semibold mb-2 text-center text-sky-800">Discover Our Services</h1>
                </div>
            </div>
            <Section
                imageLeft={false}
                color="bg-blue-400"
                title="Network Planning & Design"
                text="Complete network design services from backbone infrastructure to final demarcation."
                image={telecom}
                serviceId="network-planning"
            />
            <Section
                imageLeft={true}
                color="bg-green-400"
                title="FTTX & Premises Infrastructure"
                text="Specialized design for fibre networks across residential, commercial, and institutional developments."
                image={cables}
                serviceId="ftth-premises"
            />
            <Section
                imageLeft={false}
                color="bg-purple-400"
                title="Project Execution & Construction Management"
                text="Managing execution across phases to ensure projects stay on time, on budget, and to spec."
                image={projectMgmt}
                serviceId="project-execution"
            />
            <Section
                imageLeft={true}
                color="bg-yellow-400"
                title="Permitting & Regulatory Coordination"
                text="Liaising with local planning departments and other governmental organizations to get the necessary permits for project completion"
                image={stakeholder}
                serviceId="permitting"
            />
            <Section
                imageLeft={false}
                color="bg-red-400"
                title="Right-of-Way & Easement Management"
                text="Designing and facilitating access to public and private land for infrastructure deployment."
                image={houses}
                serviceId="right-of-way"
            />
            <Section
                imageLeft={true}
                color="bg-red-400"
                title="GIS & Documentation Services"
                text="Supporting spatial analysis, digital records, and construction documentation throughout the project lifecycle."
                image={rightOfWay}
                serviceId="gis-documentation"
            />
        </div>
        <div className="bg-gray-100 w-full pb-24 pt-8 px-12">
            <div className="max-w-6xl mx-auto text-center">
                <h2 className="text-2xl font-semibold mb-2 text-center text-sky-800">Why Anterro</h2>
                <ul className="list-disc list-inside space-y-1 text-base text-gray-700 text-left w-full">
                    <li>
                        <span className="font-bold">Industry-Experienced Professionals</span> Our team has deep expertise across telecom, civil, and planning disciplines, with
                        proven experience on major infrastructure projects across Canada.
                    </li>
                    <li>
                        <span className="font-bold">Agile, Detail-Driven Design Process</span> We use a flexible and precise design process that adapts quickly to changing site
                        conditions and project requirements.
                    </li>
                    <li>
                        <span className="font-bold">Scalable Solutions with Future-Ready Thinking</span> We design infrastructure that supports long-term growth and integrates with
                        evolving technologies and urban plans.
                    </li>
                    <li>
                        <span className="font-bold">Committed to Quality, Compliance, and Client Success</span> We prioritize regulatory compliance, streamlined permitting, and
                        practical designs that help our clients succeed.
                    </li>
                    <li>
                        <span className="font-bold">Creative Problem Solving and Collaborative Brainstorming</span> We approach every challenge with a collaborative mindset and a
                        focus on smart, buildable solutions.
                    </li>
                </ul>
                <button className="mt-6 px-8 py-3 bg-sky-700/80 text-white rounded-lg border-2 border-transparent hover:border-white transition-colors">
                    <Link to="/contact">Get in Touch</Link>
                </button>
            </div>
        </div>
    </div>
);

const About = () => (
    <div className="p-6 !p-0">
        <div className="w-full bg-gray-200 py-16">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between px-6 gap-10">
                <div className="w-full md:w-1/2 flex justify-center mb-8 md:mb-0">
                    <img src={teamwork} alt="Contact Anterro" className="rounded-3xl shadow-lg w-full max-w-md object-cover" style={{ minHeight: '200px', maxHeight: '320px' }} />
                </div>
                <div className="w-full md:w-1/2 text-center flex flex-col items-start items-center">
                    <h2 className="text-2xl font-semibold mb-4 text-sky-800">A Team Dedicated to Telecom Excellence</h2>
                    <p className="text-base text-gray-700 mb-4">
                        At Anterro, we are a multidisciplinary team of engineers, designers, and project managers passionate about building the digital infrastructure that connects
                        communities. Our ethos is rooted in collaboration, technical rigor, and a commitment to delivering practical, future-ready solutions for our clients. With
                        expertise spanning network planning, permitting, GIS, construction management, and stakeholder coordination, we bring a holistic approach to every project,
                        ensuring quality, compliance, and client success at every stage.
                    </p>
                </div>
            </div>
        </div>
        {/* <div className="max-w-6xl mx-auto w-full py-12 px-6 text-center">
            <h2 className="text-2xl font-semibold mb-4 text-sky-800">Meet Our Team</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 justify-items-center">
                {team.map((member, idx) => (
                    <div key={idx} className="flex flex-col items-center bg-white border border-gray-200 rounded-3xl shadow-md p-6 w-full max-w-s">
                        <img src={member.photo} alt={member.name} className="w-40 h-40 rounded-full object-cover shadow-lg mb-4 border-2 border-gray-600" />
                        <h3 className="text-xl font-semibold mb-2 text-center text-black">{member.name}</h3>
                        <span className="text-l font-semibold mb-2 text-center text-sky-800">{member.title}</span>
                        <hr className="w-48 border-t-2 border-gray-600 mb-4" />
                        <p className="text-md text-gray-700 mb-4">{member.bio}</p>
                    </div>
                ))}
            </div>
        </div> */}
    </div>
);

// const Portfolio = () => (
//     <div className="p-6">
//         <div className="max-w-5xl mx-auto w-full">
//             <h1 className="text-4xl font-semibold mb-2 text-center text-sky-800">Our Work</h1>
//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
//                 <div className="bg-blue-300 aspect-square flex items-center justify-center rounded-3xl shadow text-white font-semibold">Project 1</div>
//                 <div className="bg-green-300 aspect-square flex items-center justify-center rounded-3xl shadow text-white font-semibold">Project 2</div>
//                 <div className="bg-purple-300 aspect-square flex items-center justify-center rounded-3xl shadow text-white font-semibold">Project 3</div>
//                 <div className="bg-red-300 aspect-square flex items-center justify-center rounded-3xl shadow text-white font-semibold">Project 4</div>
//                 <div className="bg-yellow-300 aspect-square flex items-center justify-center rounded-3xl shadow text-white font-semibold">Project 5</div>
//                 <div className="bg-indigo-300 aspect-square flex items-center justify-center rounded-3xl shadow text-white font-semibold">Project 6</div>
//             </div>
//         </div>
//     </div>
// );

const pastelBgColors = ['bg-gray-200', 'bg-gray-100', 'bg-sky-100', 'bg-gray-200', 'bg-gray-100', 'bg-sky-100'];

const Services = () => (
    <div className="p-6 !p-0">
        <div className="max-w-6xl mx-auto w-full py-12 px-6 text-center">
            <h1 className="text-4xl font-semibold mb-2 text-center text-sky-800">Comprehensive Design Solutions</h1>
            <p className="text-base text-gray-700 mb-4">
                Anterro provides comprehensive telecom infrastructure design, project management, permitting, and documentation services. Explore our core offerings below.
            </p>
            <hr className="my-16 border-t-2 border-sky-900 mx-auto" />
            <div className="flex flex-wrap gap-8 justify-center">
                {servicesData.map((section, idx) => {
                    const isFullWidth = section.subsections && section.subsections.length > 0 && (idx + 1) % 3 === 0;
                    if (isFullWidth) {
                        return (
                            <section
                                key={section.id}
                                id={section.id}
                                className={`w-full ${pastelBgColors[idx % pastelBgColors.length]} rounded-3xl shadow-md p-8 flex flex-col items-center`}
                            >
                                <h2 className="text-2xl font-semibold mb-2 text-center text-sky-800">{section.title}</h2>
                                <div className="flex flex-col md:flex-row gap-8 w-full justify-center">
                                    {section.subsections.map((sub, j) => (
                                        <div key={j} className="flex-1 text-left">
                                            <h3 className="text-xl font-semibold mb-2 text-sky-800">{sub.subtitle}</h3>
                                            <ul className="list-disc list-inside space-y-1 text-base text-gray-700 text-left w-full">
                                                {sub.points.map((p, k) => (
                                                    <li key={k}>{p}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>
                            </section>
                        );
                    }
                    return (
                        <section
                            key={section.id}
                            id={section.id}
                            className={`flex-1 ${pastelBgColors[idx % pastelBgColors.length]} rounded-3xl shadow-md p-8 flex flex-col items-center`}
                            style={{ flexBasis: '350px' }}
                        >
                            <h2 className="text-2xl font-semibold mb-2 text-center text-sky-800">{section.title}</h2>
                            <ul className="list-disc list-inside space-y-1 text-base text-gray-700 text-left w-full">
                                {section.points.map((point, i) => (
                                    <li key={i}>{point}</li>
                                ))}
                            </ul>
                        </section>
                    );
                })}
            </div>
        </div>
        <div className="w-full bg-sky-800 py-16 mt-20">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between px-6 gap-10">
                <div className="w-full md:w-1/2 flex justify-center mb-8 md:mb-0">
                    <img src={meeting} alt="Contact Anterro" className="rounded-3xl shadow-lg w-full max-w-md object-cover" style={{ minHeight: '200px', maxHeight: '320px' }} />
                </div>
                <div className="w-full md:w-1/2 text-left flex flex-col items-start items-center">
                    <h2 className="text-3xl font-semibold mb-4 text-white">Ready to Start Your Project?</h2>
                    <p className="text-lg text-white/90 mb-6 text-center">
                        Reach out to our team to discuss your telecom infrastructure needs, request a quote, or learn more about how Anterro can help you achieve your goals.
                    </p>
                    <Link
                        to="/contact"
                        className="px-8 py-3 bg-white text-sky-800 rounded-lg border-2 border-transparent hover:border-gray-700 transition-colors text-base font-semibold shadow"
                    >
                        Contact Us
                    </Link>
                </div>
            </div>
        </div>
    </div>
);

// const Contact = () => (
//     <div className="relative flex flex-col items-center justify-center min-h-screen overflow-hidden">
//         {/* Full-width background image */}
//         <img src={trees} alt="Contact Background" className="absolute inset-0 w-full h-full object-cover z-0" />
//         {/* Overlay for darkening the image */}
//         <div className="absolute inset-0 w-full h-full bg-black/40 z-10"></div>
//         {/* Contact Form Overlay */}
//         <div className="relative z-20 max-w-xl mx-auto bg-white/90 p-10 text-center rounded-3xl shadow flex flex-col justify-center items-center mt-16 mb-16 mx-4">
//             <h1 className="text-3xl font-semibold mb-2 text-center text-sky-800">Let Us Know How We Can Help</h1>
//             <p className="text-md text-gray-700 mb-4">
//                 Interested in our telecom infrastructure services or have a project in mind? Fill out the form below and our team will get back to you promptly to discuss your
//                 needs and how we can help.
//             </p>
//             <form className="w-full flex flex-col gap-4">
//                 <input type="text" placeholder="Your Name" className="border border-gray-300 rounded px-4 py-2" required />
//                 <input type="text" placeholder="Your Company" className="border border-gray-300 rounded px-4 py-2" />
//                 <input type="email" placeholder="Your Email" className="border border-gray-300 rounded px-4 py-2" required />
//                 <textarea placeholder="Your Message" className="border border-gray-300 rounded px-4 py-2" rows={4} required />
//                 <button
//                     type="submit"
//                     className="mt-2 px-6 py-2 bg-sky-700/80 text-white rounded-lg border-2 border-transparent hover:border-sky-700 transition-colors text-base font-semibold"
//                 >
//                     Send Message
//                 </button>
//             </form>
//             <hr className="my-8 border-t-2 border-black w-2/3 mx-auto" />
//             <div className="w-full">
//                 <h2 className="text-2xl font-semibold mb-2 text-center text-sky-800">Prefer email?</h2>
//                 <p className="text-md text-gray-700 mb-4">Reach out to us anytime at:</p>
//                 <a href="mailto:info@anterro.ca" className="block text-base font-semibold text-sky-400 hover:underline mb-4 break-all" style={{ letterSpacing: '0.5px' }}>
//                     info@anterro.ca
//                 </a>
//             </div>
//         </div>
//     </div>
// );

const Contact = () => (
    <div
        className="relative flex flex-col items-center justify-center bg-center bg-cover"
        style={{
            backgroundImage: `url(${trees})`,
            height: `calc(100vh - ${NAVBAR_HEIGHT}px - 116px)`, // Changed from 120px to 116px (added 4px)
            backgroundAttachment: 'fixed',
        }}
    >
        <div className="absolute inset-0 w-full h-full bg-black/40"></div>
        <div className="relative z-20 w-full max-w-xs sm:max-w-lg md:max-w-xl lg:max-w-2xl mx-auto bg-white/90 py-8 sm:py-12 md:py-16 lg:py-20 px-6 sm:px-8 md:px-10 lg:px-12 text-center rounded-3xl shadow flex flex-col justify-center items-center my-4 sm:my-8 md:my-12 lg:my-16 mx-4">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-4 sm:mb-6 md:mb-8 text-center text-sky-800">Get In Touch</h1>
            <p className="text-base text-gray-700 mb-6 sm:mb-8 md:mb-10 lg:mb-12 leading-relaxed">
                Ready to discuss your telecom infrastructure project? We're here to help with network planning, design, permitting, and project management services. Reach out to
                learn more about how Anterro can support your goals.
            </p>
            <a
                href="mailto:info@anterro.ca"
                className="block text-lg sm:text-xl md:text-2xl font-semibold text-sky-700 hover:text-sky-900 hover:underline mb-4 sm:mb-6 md:mb-8 transition-colors"
                style={{ letterSpacing: '0.5px' }}
            >
                info@anterro.ca
            </a>
        </div>
    </div>
);

const NAVBAR_HEIGHT = 72; // px, adjust if your navbar height changes

const App = () => (
    <Router>
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar />
            {/* Add top padding equal to navbar height */}
            <div className="flex-grow" style={{ paddingTop: NAVBAR_HEIGHT }}>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    {/* <Route path="/portfolio" element={<Portfolio />} /> */}
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/services" element={<Services />} />
                </Routes>
            </div>
            <Footer />
        </div>
    </Router>
);

export default App;
